import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import { useLanguage } from 'Context/LanguageContext';
const LocationFormatter = ({showLocationIcon}) => {
  const lan = useLanguage();
  return (
    <div className='row no-padding'>
      {showLocationIcon && (
        <Tooltip title={lan.newLocationAvailable}>
          <NotListedLocationIcon color='disabled' />
        </Tooltip>
      )}
    </div>
  );

}
export default LocationFormatter;
